import { gql } from '../../../../../hooks'

export const DELETE_CHANGE_REFILL_MOTIVES = gql`
  mutation AdministrationDeleteLubricantChangeRefillMotives($id: ID!) {
    aDelete(path: "lubricant/change/refill/motives", id: $id) {
    }
  }
`

export const LIST_CHANGE_REFILL_MOTIVES = gql`
  query AdministrationListLubricantChangeRefillMotives(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "lubricant/change/refill/motives"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
